import { Component, Input } from '@angular/core';
import { NgbTimepickerConfig, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { InputComponent } from '../input/input.component';

@Component({
	selector: 'cfe-input-time',
	templateUrl: './input-time.component.html',
	styleUrls: ['./input-time.component.scss'],
	providers: []
})
export class InputTimeComponent extends InputComponent {
	public valuesDayEarly: string[] = [];
	public valuesDayLate: string[] = [];
	public valuesNightEarly: string[] = [];
	public valuesNightLate: string[] = [];
	public minutes: string[] = [];
	public allValues = [];
	public activeHour: number;
	public activeMinute: number;

	constructor() {
		super();
		this.valuesDayEarly = ['6', '7', '8', '9', '10', '11'];
		this.valuesDayLate = ['12', '1', '2', '3', '4', '5'];
		this.valuesNightEarly = ['6', '7', '8', '9', '10', '11'];
		this.valuesNightLate = ['12', '1', '2', '3', '4', '5'];
		this.minutes = ['00', '15', '30', '45'];
		this.allValues.push([this.valuesDayEarly]);
		this.allValues.push([this.valuesDayLate]);
		this.allValues.push([this.valuesNightEarly]);
		this.allValues.push([this.valuesNightLate]);
	}

	/**
	 * Angular onInit lifecycle hook
	 */
	cfeOnInit() {}

	/**
	 *
	 * @param number
	 * @param index
	 */
	clickedHour(number: string, index: number) {
		this.activeHour = index;
	}
	clickedMinute(number: string, index: number) {
		this.activeMinute = index;
	}
}
